import { ORGANIZATION_ID_URL_QUERY_PARAM } from "../Constants"

    /**
     * @param name
     * @returns 
     */
    export const getUrlParameter = (name) => {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
        const results = regex.exec(window.location.search)
        return results === null
            ? ''
            : decodeURIComponent(results[1].replace(/\+/g, ' '))
    }

    /**
     * Preload asset or catalog with organization id in url instead of the one in the localstorage if the url param ORGANIZATION_ID_URL_QUERY_PARAM is present
     * @param name
     * @returns {string | null}
     */
    export const getCurrentOrganizationUrlParam = () => {
        let name = ORGANIZATION_ID_URL_QUERY_PARAM;
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
        let results = regex.exec(window.location.search)
        results = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))

        // return null if ORGANIZATION_ID_URL_QUERY_PARAM is not present
        if(!results) return "";

        const selectedOrg = JSON.parse(localStorage.getItem("selectedOrg") || "{}");

        // If ORGANIZATION_ID_URL_QUERY_PARAM is present, confirm if 
        // the current users organization persisted to the localStorage is "All Organizations" then 
        // ignore returning the ORGANIZATION_ID_URL_QUERY_PARAM
        if(!(selectedOrg && selectedOrg?.organization_id)) 
            return ""

        return Array.isArray(results) ? results[1]: results;
    }